import React from 'react';
import { Notification as NotificationDS } from '@wix/design-system';

export interface NotificationProps {
  label: string;
  actionButtonType: 'textLink' | 'button';
  onClickActionButton?: () => void;
  labelActionButton?: string;
  show: boolean;
  onClose?: () => void;
}

export const Notification = ({
  label,
  onClickActionButton,
  labelActionButton,
  actionButtonType = 'button',
  show,
  onClose,
}: NotificationProps) => {
  return (
    <NotificationDS show={show} onClose={onClose}>
      <NotificationDS.TextLabel>{label}</NotificationDS.TextLabel>
      {!!labelActionButton && (
        <NotificationDS.ActionButton
          type={actionButtonType}
          onClick={onClickActionButton}
        >
          {labelActionButton}
        </NotificationDS.ActionButton>
      )}
      <NotificationDS.CloseButton />
    </NotificationDS>
  );
};
